import $ from "jquery";

require("../vendor/jquery.easing");

export class CalloutCollar {
  constructor(options) {
    this.options = options;
    this.$collar = options.$collar;
    this.$viewport = this.$collar.find(".viewport");
    this.$slider = this.$collar.find(".slider");
    this.$callouts = this.$collar.find(".object.bordered");

    this._index = 0;
    this._total = this.$callouts.length - 1;
    this._left = 0;
    this._animating = false;

    this.init();
  }

  init() {
    var totalWidth = 0;
    this.$callouts.each(function() {
      totalWidth += $(this).outerWidth(true);
    });

    this.$callouts.each(function() {});
    // If we have a slider, responsify it
    if (this.$slider.length) {
      this.responsify();
    }

    if (totalWidth >= this.$viewport.outerWidth(true)) {
      this.$collar.on("click", ".arrow", $.proxy(this.advance, this));
    } else {
      this.$collar.find(".arrow").hide();
    }
  }

  advance(e) {
    if (!this._animating) {
      this._animating = true;

      var $target = $(e.currentTarget);
      var direction = $target.hasClass("next") ? "next" : "previous";
      var index = this._index + (direction == "next" ? 1 : -1);

      if (direction == "next") {
        var original = this.$callouts.eq(0);
        var clone = original.clone();
        clone.appendTo(this.$slider);

        var cloneWidth = clone.outerWidth(true);
        var left = this._left - cloneWidth;
      } else {
        var original = this.$callouts.eq(this._total);
        var clone = original.clone();
        clone.prependTo(this.$slider);

        this.$slider.css({
          left: -clone.outerWidth(true)
        });
        var left = 0;
      }

      this.$slider.animate(
        {
          left: left
        },
        250,
        "easeOutQuad",
        $.proxy(function() {
          original.remove();
          this.$callouts = this.$collar.find(".object.bordered");
          if (typeof cloneWidth !== "undefined") {
            left += cloneWidth;
            this.$slider.css({
              left: left
            });
          }
          this._left = left;
          this._animating = false;
        }, this)
      );
    }
  }
  responsify() {
    // Get viewport width
    var viewportWidth = this.$viewport.outerWidth(true);

    // Calculate callout width
    if (this.$callouts.first().hasClass("w33") && viewportWidth > 600) {
      var calloutWidth = Math.ceil(viewportWidth / 3);
    } else if (this.$callouts.first().hasClass("w50") && viewportWidth > 600) {
      var calloutWidth = Math.ceil(viewportWidth / 2);
    } else {
      var calloutWidth = viewportWidth;
    }

    // Calculate width of slider (add 1 because the carousel is continuous)
    var sliderWidth = calloutWidth * (this.$callouts.length + 1);

    // Add calculated widths to elements
    this.$callouts.css(
      "width",
      ((calloutWidth - 12) / sliderWidth) * 100 + "%"
    );
    this.$slider.css("width", sliderWidth);
  }
}
